import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HubComponent } from '../hub/hub.component';
import { HojasCallCenterComponent } from './hojas-call-center.component';
import {OpenComponent} from "./open/open.component";

//import { HojasCallCenterRoutingModule } from './hojas-call-center-routing.module';

export const SUBROUTES: Routes = [
  { path: '', component: HojasCallCenterComponent, children: [] },
  { path: ':piloto/:id', component: HojasCallCenterComponent, children: [] },
  { path: 'open', component: OpenComponent, children: [] },
  { path: 'hub', component: HubComponent }
];

@NgModule({
  imports: [RouterModule.forChild(SUBROUTES)],
  exports: [RouterModule]
})

export class HojasCallCenterRoutingModule { }
